import React from 'react';
import { useSelector } from 'react-redux';
import { selectCmsLayoutData } from '../../../store/slices/cmsSlice';
import { CmsRenderer } from '../../../services/cms';
import type { CmsNode } from '../../../services/cms/cmsComponentRegistry';
import { MainContentCmsContainer, StyledProductCard } from './style';

interface MainContentCmsProps {
  product?: {
    productName?: string;
  };
}

/**
 * MainContentCms - CMS-driven main content component
 *
 * This component renders UI dynamically based on CMS configuration.
 * Uses CardV2 as the top-level container with product name as title
 * and dynamically rendered tabs in the body.
 * Loading state is handled at LayoutV2 level.
 */
const MainContentCms: React.FC<MainContentCmsProps> = () => {
  // Get CMS layout data from Redux
  const layoutData = useSelector(selectCmsLayoutData);

  // Extract the product node from layout data
  const productNode: CmsNode | null = layoutData?.product ?? null;

  // Card body content - dynamically rendered from CMS
  const cardBodyContent =
    productNode !== null ? (
      <CmsRenderer
        node={productNode}
        fallback={
          <div
            style={{
              padding: '16px',
              backgroundColor: '#fff3cd',
              borderRadius: '4px',
              color: '#856404',
            }}
          >
            Unable to render CMS component
          </div>
        }
      />
    ) : (
      <div
        style={{
          padding: '16px',
          backgroundColor: '#fff3cd',
          borderRadius: '4px',
          color: '#856404',
        }}
      >
        No CMS layout configured for this product.
      </div>
    );

  return (
    <MainContentCmsContainer>
      <StyledProductCard
        state="non-interactive"
        type="basic"
        cardBody={{
          type: 'slot',
          slot: cardBodyContent,
        }}
      />
    </MainContentCmsContainer>
  );
};

export default MainContentCms;
